
export const colors = {
    bg_system: '#F7B500',
    bg_text_primary: '#0D4774',
    bg_text_secondary: '#7C9CB4',
    bg_text_teriaty: '#A6BCCC',
    bg_white: '#FFFFFF',
    bg_text_disabled: '#DBE4EB',
    bg_border_primary: '#DAE6F0',
    bg_border_seperator: '#E2E7EB',
    bg_background_primary: '#F3F7FA',
    bg_background_secondary: '#FAFCFD',
    bg_background_overlay: '#7F7F7F',
    bg_background_fields: '#F6F8FA',
    bg_error: '#e02020',
    //-----------------------------------------------------------------
    tx_system: '#F7B500',
    tx_text_primary: '#0D4774',
    tx_text_secondary: '#7C9CB4',
    tx_text_teriaty: '#A6BCCC',
    tx_white: '#FFFFFF',
    tx_text_disabled: '#DBE4EB',
    tx_border_primary: '#DAE6F0',
    tx_border_seperator: '#E2E7EB',
    tx_background_primary: '#F3F7FA',
    tx_background_secondary: '#FAFCFD',
    tx_background_overlay: '#7F7F7F',
    tx_background_fields: '#F6F8FA',
    tx_error: '#e02020',
    //----------------------------------------------------------------
    btnGreenBg: '#52c483',
    successGreenText: '#00a35a',
    successGreenBg: '#01e27d',
    black: '#000',
    opacityBackground: '#0D4774',
    bg_system_gradient: '#F7C500',
  
    t_green: '#24C875',
    b_green: '#E5F8EE',
  };


export const typography = {
  browserBaseFontSize: 16,
  // `px` value, all CSS `rem` values will be relative to this value
  rootFontSize: 10,
  // `body` font-size multiplier of `rootFontSize`
  globalBodyFontSizeBase: 1.8,
  fontPrimary: 'Montserrat',
};